import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RedirectToV2Guard implements CanActivate {

  constructor() { }

  canActivate(): boolean {
    if (environment.redirectToV2) {
      window.location.href = environment.redirectToV2;
      return false;
    }
    return true;
  }
} 